import { motion } from "framer-motion";

const LEADERSHIP = [
  {
    name: "Chris Dickson",
    role: "Chief Executive Officer",
    tag: "Command",
    linkedin: "https://www.linkedin.com/in/chris-dickson-63823913/",
  },
  {
    name: "Dr. Marlin McNichols",
    role: "Chief Operating Officer",
    tag: "100+ Gold & Platinum Records · 4× Grammy Nominee",
    linkedin: "https://www.linkedin.com/in/dr-marlin-mcnichols-064a745/",
  },
  {
    name: "Judge O'Riordan",
    role: "Judge",
    tag: "Sound Advice, LLC",
    linkedin: null,
  },
];

const EXECUTIVES = [
  {
    name: "Ryan Love",
    role: "Network Executive",
    region: "U.S. Development & Growth",
    linkedin: "https://www.linkedin.com/in/launchpadtv/",
  },
  {
    name: "Terry Dillard",
    role: "Network Executive",
    region: "U.S. Development & Growth",
    linkedin: null,
  },
  {
    name: "Bassey Essien",
    role: "Network Executive",
    region: "Nigeria",
    linkedin: "https://www.linkedin.com/in/bassey-essien-b635a7124",
  },
  {
    name: "Henryson Oladipo Balogun",
    role: "UK Account Executive",
    region: "IP Creator Development",
    linkedin: null,
  },
];

const initials = (name) =>
  name
    .replace(/^Dr\.\s*/, "")
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const LinkedInBadge = ({ url, name }) =>
  url ? (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${name} on LinkedIn`}
      data-testid={`linkedin-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      className="flex items-center justify-center w-9 h-9 border border-white/10 glass-panel hover:border-signal/70 transition-colors duration-300"
    >
      <img src="/social/linkedin.svg" alt="" className="w-4 h-4" />
    </a>
  ) : null;

const CrewCard = ({ person, i, region }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ y: -6 }}
    className="group relative glass-panel p-7 overflow-hidden"
    data-testid={`crew-${person.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
  >
    <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-signal/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    <div className="flex items-start justify-between">
      <div className="flex items-center justify-center w-14 h-14 rounded-full border border-signal/40 bg-signal/10 font-head font-extrabold text-signal text-lg">
        {initials(person.name)}
      </div>
      <LinkedInBadge url={person.linkedin} name={person.name} />
    </div>
    <h3 className="mt-5 font-head font-bold tracking-tight text-lg text-white">{person.name}</h3>
    <div className="mt-1 font-mono text-[10px] tracking-[0.2em] uppercase text-slate-400">
      {person.role}
    </div>
    <div className="mt-3 font-mono text-[9px] tracking-[0.2em] uppercase text-signal/80">
      {region || person.tag}
    </div>
  </motion.div>
);

export default function Team() {
  return (
    <section id="team" className="relative py-24 lg:py-32 px-4 sm:px-8 lg:px-16 bg-charcoal/40 border-y border-white/5" data-testid="team-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex items-end justify-between gap-6 mb-14"
        >
          <div>
            <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-signal">
              The Crew
            </span>
            <h2 className="mt-3 font-head font-extrabold tracking-tight text-base md:text-lg text-slate-300 max-w-xl leading-relaxed">
              Legends at the desk. Operators in the field.
            </h2>
          </div>
          <span className="hidden sm:block font-mono text-[11px] tracking-[0.25em] uppercase text-slate-500">
            PERSONNEL // 007
          </span>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {LEADERSHIP.map((p, i) => (
            <CrewCard key={p.name} person={p} i={i} />
          ))}
        </div>

        <div className="mt-10 mb-6 flex items-center gap-4">
          <span className="h-px flex-1 bg-white/10" />
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-slate-500">
            Network Executives
          </span>
          <span className="h-px flex-1 bg-white/10" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {EXECUTIVES.map((p, i) => (
            <CrewCard key={p.name} person={p} i={i + 3} region={p.region} />
          ))}
        </div>
      </div>
    </section>
  );
}
